(() => {
  // Set the height of the container based on the image aspect ratio
  setContainerHeight();
  window.addEventListener("resize", setContainerHeight);
  // for collection slider
  carouselElement();
  // Updates hours of operation status
  updateStoreStatus({
    open: 9,
    close: 17,
    textContainer: document.getElementById("store-status"),
  });

  // FUNCTIONS
  function setContainerHeight() {
    const containers = document.querySelectorAll(".autoheight");

    containers.forEach((container) => {
      const image = container.querySelector("img");

      if (image) {
        const width = container.offsetWidth;
        const ratio = image.naturalHeight / image.naturalWidth;
        const height = width * ratio;

        container.style.height = `${height}px`;
      }
    });
  }
  window.addEventListener("resize", setContainerHeight);

  /**
   * Updates the store status based on the current time.
   * @param {Object} options - The options for updating the store status.
   * @param {number} options.open - The opening hour of the store.
   * @param {number} options.close - The closing hour of the store.
   * @param {HTMLElement} options.textContainer - The container element to display the store status.
   */
  function updateStoreStatus({ open, close, textContainer }) {
    if (!textContainer) return;
    function toPST(date) {
      const utc = date.getTime() + date.getTimezoneOffset() * 60000;
      return new Date(utc - 3600000 * 8);
    }

    const now = toPST(new Date());
    const day = now.getDay();
    const hours = now.getHours();

    if (day >= 1 && day <= 5) {
      if (hours < open) {
        textContainer.innerHTML =
          "Customer service is currently closed. Opens at 9:00 AM.";
      } else if (hours >= close) {
        textContainer.innerHTML =
          "Customer service is currently closed. Opens tomorrow at 9:00 AM.";
      } else {
        textContainer.innerHTML = "Customer service is currently open.";
      }
    } else {
      textContainer.innerHTML = "Customer service is closed today.";
    }
  }

  /* eslint-env browser */

  function carouselElement() {
    const slider = document.querySelector(".tws__slider");
    if (!slider) return;
    const slide = slider.querySelector(".tws__slide-list");
    const next = slider.querySelector(".pro-next");
    const prev = slider.querySelector(".pro-prev");
    const need_loop = document.querySelector(".tws__ctrl").hasAttribute("data-loop");
    const itemsWidth = 690;
    const itemsPerStep = 1;

    let currentSlide = 0;
    let totalSlides = slide.children.length;
    let totalItems = slide.children.length;

    function updateSlider() {
      slide.style.transform = `translateX(-${currentSlide * itemsWidth}px)`;

      // if not need loop, will hidden next and prev buttion when match condition
      if (!need_loop) {
        // Hide next button if in the last slide
        if (currentSlide === totalSlides - itemsPerStep) {
          next.style.display = "none";
        } else {
          next.style.display = "block";
        }
        // Hide prev button if in the first slide
        if (currentSlide === 0) {
          prev.style.display = "none";
        } else {
          prev.style.display = "block";
        }
      }
    }

    function nextSlide() {
      currentSlide += itemsPerStep;
      if (currentSlide > totalSlides - itemsPerStep) {
        if (need_loop) {
          currentSlide = 0;
        } else {
          currentSlide = totalSlides - itemsPerStep;
        }
      }

      updateSlider();
    }

    function prevSlide() {
      currentSlide -= itemsPerStep;
      if (currentSlide < 0) {
        if (need_loop){
          currentSlide = totalSlides - itemsPerStep;
        } else {
          currentSlide = 0;
        }
      }

      updateSlider();
    }

    next.addEventListener("click", nextSlide);
    prev.addEventListener("click", prevSlide);

    window.addEventListener("resize", () => {
      totalSlides = Math.ceil(totalItems / itemsPerStep);
      updateSlider();
    });

    updateSlider();
  }
  const imageOvrelayBtn = document.querySelectorAll(
    ".img-wrp .svg-wrp .imageOvrelaybtn"
  );
  if (imageOvrelayBtn != null) {
    // const imageOvrelayText = document.querySelectorAll('.img-wrp .image-ovrelayContent');
    imageOvrelayBtn.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const imageOvrelayText = button.closest(".img-wrp");
        // button.classList.remove("is--active");
        if (button.classList.contains("is--active")) {
          button.classList.remove("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.remove("is--active");
        } else {
          // imageOvrelayBtn.classList.remove("is--active");
          button.classList.add("is--active");
          imageOvrelayText
            .querySelector(".image-ovrelayContent")
            .classList.add("is--active");
        }
      });
    });
  }
})();


document.addEventListener('DOMContentLoaded', function () {
   /**
   * V Filter Checklist - Interactive image switcher
   * Mobile: First item active by default
   * Desktop: No item active, shows default image
   */
   function initFilterChecklist() {
    const checklists = document.querySelectorAll('.v-filter-checklist');
    
    checklists.forEach(function(el) {
      const sectionId = el.getAttribute('data-section-id');
      const initKey = 'filter_checklist_init_' + sectionId;
      
      // Skip if already initialized
      if (window[initKey]) return;
      window[initKey] = true;
      
      const items = el.querySelectorAll('.v-filter-checklist__item');
      const images = el.querySelectorAll('.v-filter-checklist__image:not(.v-filter-checklist__image--default)');
      const defaultImage = el.querySelector('.v-filter-checklist__image--default');
      const listWrapper = el.querySelector('.v-filter-checklist__list-wrapper');
      
      /**
       * Switch to specific item
       * @param {number} index - Item index (-1 shows default image)
       */
      function switchItem(index) {
        // Remove active from all items and images
        items.forEach(function(item) {
          item.classList.remove('active');
        });
        images.forEach(function(img) {
          img.classList.remove('active');
        });
        
        if (index >= 0 && index < items.length) {
          // Activate specific item
          items[index].classList.add('active');
          images[index].classList.add('active');
          // Hide default image
          if (defaultImage) {
            defaultImage.classList.add('hidden');
          }
        } else {
          // Show default image
          if (defaultImage) {
            defaultImage.classList.remove('hidden');
          }
        }
      }
      
      /**
       * Reset to default state (show default image)
       */
      function resetToDefault() {
        switchItem(-1);
      }
      
      /**
       * Check if mobile viewport
       */
      function isMobile() {
        return window.innerWidth < 700;
      }
      
      // Add event listeners
      items.forEach(function(item) {
        const index = parseInt(item.getAttribute('data-index'));
        
        // Click for both mobile and desktop
        item.addEventListener('click', function(e) {
          e.preventDefault();
          switchItem(index);
        });
        
        // Hover for desktop only
        item.addEventListener('mouseenter', function() {
          if (!isMobile()) {
            switchItem(index);
          }
        });
      });
      
      // Mouse leave - reset to default on desktop
      if (listWrapper) {
        listWrapper.addEventListener('mouseleave', function() {
          if (!isMobile()) {
            resetToDefault();
          }
        });
      }
      
      // Initialize: Mobile shows first item, Desktop shows default image
      if (isMobile()) {
        switchItem(0);
      } else {
        resetToDefault();
      }
    });
  }
  
  // Initialize on load
  initFilterChecklist();
  
  // Shopify editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      const section = document.querySelector('#shopify-section-' + e.detail.sectionId + ' .v-filter-checklist');
      if (section) {
        window['filter_checklist_init_' + e.detail.sectionId] = false;
        setTimeout(initFilterChecklist, 100);
      }
    });
  }
  /**
   * V Filter Checklist end
   */
})
